import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { BorderFrameProps } from "../types";

const BorderFrame = ({ children }: BorderFrameProps) => {
    const { gray200 } = colors;

    return (
        <div
            css={css({
                border: `1px solid ${gray200}`,
                borderRadius: "12px"
            })}
        >
            {children}
        </div>
    );
};

export { BorderFrame };
